export enum ActiviteitTypeEnum {
  KEURING_STOOKTOESTEL = 'KEURING_STOOKTOESTEL',
  ONDERHOUD_STOOKTOESTEL = 'ONDERHOUD_STOOKTOESTEL',
}
